function getSamePageHash(rawHref) {
	const href = typeof rawHref === 'string' ? rawHref.trim() : '';
	if (!href) return '';
	if (href.startsWith('#')) return href;

	try {
		const url = new URL(href, window.location.href);
		if (url.origin !== window.location.origin) return '';
		if (url.pathname !== window.location.pathname) return '';
		return url.hash || '';
	} catch (error) {
		return '';
	}
}

export default {
	init() {
		const layouts = document.querySelectorAll('.layout.nav-bar');
		if (!layouts.length) return;

		layouts.forEach((layout) => {
			const nav = layout.querySelector('.nav-bar-nav') || layout.querySelector('nav');

			const links = Array.from(layout.querySelectorAll('.nav-bar-link'));

			const items = links
				.map((link) => {
					const hash = getSamePageHash(link.getAttribute('href'));
					if (!hash || !hash.startsWith('#')) return null;
					const id = hash.slice(1);
					if (!id) return null;

					const target = document.getElementById(id);
					if (!target) return null;

					return { id, link, target };
				})
				.filter(Boolean);

			function setActive(targetId) {
				if (!links.length) return;
				links.forEach((link) => {
					link.classList.remove('is-active');
					link.removeAttribute('aria-current');
				});

				if (!targetId) return;
				const active = items.find((item) => item.id === targetId);
				if (!active) return;
				active.link.classList.add('is-active');
				active.link.setAttribute('aria-current', 'true');
			}

			function updateStickyState() {
				const styles = window.getComputedStyle(layout);
				const position = styles && styles.position ? styles.position : '';
				if (position !== 'sticky' && position !== '-webkit-sticky') {
					layout.classList.remove('is-sticky');
					return;
				}

				const topPx = parseFloat(styles.top || '0');
				const rect = layout.getBoundingClientRect();
				const isSticky = Number.isFinite(topPx) && Math.abs(rect.top - topPx) <= 2;
				layout.classList.toggle('is-sticky', isSticky);
			}

			function updateActiveLink() {
				if (!nav || !items.length) return;
				const navRect = nav.getBoundingClientRect();
				const probeY = navRect.top + 1;

				let activeId = '';
				let lastAboveId = '';

				items.forEach((item) => {
					const rect = item.target.getBoundingClientRect();
					if (rect.top <= probeY) {
						lastAboveId = item.id;
					}
					if (rect.top <= probeY && rect.bottom >= probeY && !activeId) {
						activeId = item.id;
					}
				});

				setActive(activeId || lastAboveId);
			}

			let raf = 0;
			function scheduleUpdate() {
				if (raf) return;
				raf = requestAnimationFrame(() => {
					raf = 0;
					updateStickyState();
					updateActiveLink();
				});
			}

			window.addEventListener('scroll', scheduleUpdate, { passive: true });
			window.addEventListener('resize', scheduleUpdate);

			// Initial state.
			scheduleUpdate();
		});
	},
};
